// Pure builder for the subscription widget tracking `event_data`.
// Premium tier (v1.7, CU-86ca1du79) is not implemented yet, so tier/variant
// stay on the Essentials values; the Premium-only enum members light up there.

const SUBSCRIPTION_TIER = {
  ESSENTIALS: 'essentials',
  PREMIUM: 'premium',
}

const WIDGET_VARIANT = {
  ESSENTIALS_PRIMARY_PREMIUM_UPSELL: 'essentials_primary_premium_upsell',
  PREMIUM_PRIMARY: 'premium_primary',
}

const PRICE_BAND = {
  UNDER_10: 'under_10',
  BAND_10_50: 'band_10_50',
}

const USER_SUBSCRIPTION_STATE = {
  LOGGED_OUT: 'logged_out',
  FREE: 'free',
  ESSENTIALS_ACTIVE: 'essentials_active',
  ESSENTIALS_CANCELLED: 'essentials_cancelled',
  PREMIUM: 'premium',
}

const parseDisplayedPrice = (price) => {
  if (typeof price === 'number') return Number.isFinite(price) ? price : null
  if (typeof price !== 'string') return null
  const parsed = parseFloat(price.replace(/[^0-9.]/g, ''))
  return Number.isFinite(parsed) ? parsed : null
}

const derivePriceBand = (displayedPrice) => {
  if (displayedPrice == null) return null
  return displayedPrice < 10 ? PRICE_BAND.UNDER_10 : PRICE_BAND.BAND_10_50
}

const deriveUserSubscriptionState = ({ isLoggedIn, isActiveSubscriber }) => {
  if (!isLoggedIn) return USER_SUBSCRIPTION_STATE.LOGGED_OUT
  if (isActiveSubscriber) return USER_SUBSCRIPTION_STATE.ESSENTIALS_ACTIVE
  return USER_SUBSCRIPTION_STATE.FREE
}

const deriveSubscriptionWidgetTracking = ({ price, isLoggedIn, isActiveSubscriber }) => {
  const displayedPrice = parseDisplayedPrice(price)

  return {
    subscription_tier: SUBSCRIPTION_TIER.ESSENTIALS,
    widget_variant: WIDGET_VARIANT.ESSENTIALS_PRIMARY_PREMIUM_UPSELL,
    price_band: derivePriceBand(displayedPrice),
    displayed_price: displayedPrice,
    user_subscription_state: deriveUserSubscriptionState({ isLoggedIn, isActiveSubscriber }),
  }
}

// Exported so specs lock the values and the Premium display logic (CU-86ca1du79)
// reuses these constants instead of re-declaring magic strings.
export {
  SUBSCRIPTION_TIER,
  WIDGET_VARIANT,
  PRICE_BAND,
  USER_SUBSCRIPTION_STATE,
}

export default deriveSubscriptionWidgetTracking
